import { render, staticRenderFns } from "./DepartmentsChoice.vue?vue&type=template&id=57ed10f2&scoped=true"
import script from "./DepartmentsChoice.vue?vue&type=script&lang=js"
export * from "./DepartmentsChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed10f2",
  null
  
)

export default component.exports